import { render, staticRenderFns } from "./route-citys-demo.vue?vue&type=template&id=173d2821&"
import script from "./route-citys-demo.vue?vue&type=script&lang=ts&"
export * from "./route-citys-demo.vue?vue&type=script&lang=ts&"
import style0 from "./route-citys-demo.vue?vue&type=style&index=0&id=173d2821&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports